import { AxiosInstance } from 'axios';

import { Configuration } from '@/clients/unifiedApi';
import { useAppConfigStore } from '@/piniaStores/appConfig/appConfig.store';
import { useAuthStore } from '@/piniaStores/auth/auth.store';

/**
 * Returns a configuration object for the unified API.  Throws an error if
 * the config is invalid, which is ultimately logged as a console warning.
 */
export const getApiConfig = (): Configuration => {
  const appConfigStore = useAppConfigStore();
  const accessToken = useAuthStore().accessToken;

  return new Configuration({
    basePath: appConfigStore.unifiedApiUrl,
    baseOptions: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'LeafLink-Version': '2022-10-31',
      },
    },
  });
};

/**
 * Create API from OpenAPI SDK factory method
 */
export const getUnifiedApi = <TFactory extends Record<string, unknown>>(
  apiFactory: (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) => TFactory,
): Promise<TFactory> => {
  return Promise.resolve(apiFactory(getApiConfig()));
};
